import * as React from 'react';

const Documents = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M19.74 8.33L14.3 2.33C14.11 2.12 13.842 2 13.56 2H6.56C5.163 1.983 4.017 3.102 4 4.5V19.5C4.016 20.897 5.162 22.016 6.56 22H17.44C18.837 22.017 19.983 20.898 20 19.5V9C20 8.752 19.907 8.513 19.74 8.33ZM14 5L16.74 8H14.74C14.304 7.974 13.973 7.6 13.999 7.164L14 7.15V5ZM17.44 20H6.56C6.268 20.017 6.017 19.794 6 19.502V4.5C6.016 4.208 6.266 3.984 6.558 4H12V7.15C11.966 8.683 13.177 9.956 14.71 10H18V19.5C17.984 19.792 17.734 20.016 17.442 20H17.44Z" fill="currentColor"/>
  </svg>
);

export default Documents;
